module.exports = __webpack_public_path__ + "img/ball_8.45a1fec6.png";